/**
 * Household-scoped food preferences, mirroring the backend `foodpref.Preferences`
 * shape (GET/PUT /households/{id}/food-preferences). The backend normalizes on save
 * (trims, de-dupes, bounds), so a PUT response is the canonical stored value.
 */
export interface FoodPreferences {
  /** Dietary patterns to always respect, e.g. "vegetarian". */
  diets: string[];
  /** Ingredients/foods to avoid, e.g. "cheese". */
  dislikes: string[];
  /** Cuisines the household enjoys, e.g. "mediterranean". */
  liked_cuisines: string[];
  /** Free-text extra guidance for recipe generation. */
  custom_prompt: string;
  /**
   * How many people the household usually cooks for. The assistant scales
   * generated recipes and meal plans to this count unless a request asks for
   * something else. 0 means "not set" (no default applied). The backend clamps
   * to 0..50 on save.
   */
  default_servings: number;
}

export const EMPTY_FOOD_PREFERENCES: FoodPreferences = {
  diets: [],
  dislikes: [],
  liked_cuisines: [],
  custom_prompt: '',
  default_servings: 0,
};
